import { HTTPMetricResponse } from '../http-metric-response';

export function parseMetric(httpMetric: HTTPMetricResponse): number {
	return httpMetric.count;
}
